import { useRef, useState } from 'react';

export type Position = {
  left: number;
  top: number;
};

export const useTooltip = () => {
  const ref = useRef<HTMLSpanElement>(null);
  const [position, setPosition] = useState<Position | null>(null);

  const handleMouseEnter = () => {
    if (ref.current == null) return;
    const { left, right, top, bottom } = ref.current.getClientRects()[0];
    setPosition({ left: (left + right) / 2, top: (top + bottom) / 2 });
  };

  const handleMouseLeave = () => {
    setPosition(null);
  };

  return { ref, position, handleMouseEnter, handleMouseLeave };
};
